export type AttributeSelectOption = { value: number; label: string }

const mapAttributeRows = (rows: unknown): AttributeSelectOption[] => {
  if (!Array.isArray(rows)) return []
  return rows.map((item: { id?: number; api_name?: string }) => ({
    value: item.id as number,
    label: item.api_name as string,
  }))
}

const readOptionalCount = (value: unknown): number | undefined => {
  if (value == null || value === '') return undefined
  const num = Number(value)
  return Number.isFinite(num) ? num : undefined
}

/** Paginated attribute-data payload. Never treat a rejected axios response as options. */
export const getPaginatedAttributeOptions = (
  payload: unknown
): { options: AttributeSelectOption[]; next: unknown; count: number | undefined } => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return { options: [], next: undefined, count: undefined }
  }
  const record = payload as { results?: unknown; next?: unknown; count?: unknown }
  return {
    options: mapAttributeRows(record.results),
    next: record.next,
    count: readOptionalCount(record.count),
  }
}

/** Parent-field payload: prefer `results`, else an array body. Objects without `results` are empty. */
export const getParentFieldAttributeItems = (payload: unknown): unknown[] => {
  if (Array.isArray(payload)) return payload
  if (payload && typeof payload === 'object') {
    const results = (payload as { results?: unknown }).results
    if (Array.isArray(results)) return results
  }
  return []
}
